const redirectToVisuwell = redirectTo => {
  let replaceRe = new RegExp(
    "https://www.wecounsel.develop|http://visuwell.wecounsel.tes",
    "i"
  );
  let redirectToOverride =
    process.env.VUE_APP_REDIRECT_TO_OVERRIDE || "https://www.wecounsel.develop";

  redirectTo = redirectTo.replace(replaceRe, redirectToOverride);
  window.location = redirectTo;
};

const handleApiResponse = response => {
  let data = {};
  if (response.data && response.data.data) {
    data = response.data.data;
  }
  return data;
};

const handleApiError = response => {
  if (response.response.data && response.response.data.errors) {
    var error = _.map(response.response.data.errors, err => {
      return err.detail;
    }).join(", ");
  } else {
    var error = "Something went wrong.";
  }
  return Promise.reject(error);
};

export { redirectToVisuwell, handleApiResponse, handleApiError };
